/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import { Home, Profile, ChangePassword } from 'features/components/base';
import { LocationsRouter } from './LocationsRouter';
import SalesRouter  from './SalesRouter';
import ReportRouter  from './ReportRouter';
import { BuyerRouter } from './BuyerRouter';
import { InvoiceRouter } from './InvoiceRouter';
import { MessageRouter } from './MessageRouter';
import { connect } from 'react-redux'; 
import { CtbidsContentRouter } from './CtbidsContentRouter';
import DeclinedCards from 'features/components/base/declinedcards/DeclinedCards';
import AlertRouter from './AlertRouter';
import { Fullfillment } from 'features/components/base/fullfillment/Fullfillment';
import MembershipRouter from './MembershipRouter';
import { helpCenterRouter } from './faqRouter';
import {ComplianceRouter} from './ComplinaceRouter';
/**
 * routing for base components
 * 
 * @param props
 * 
 * @return routing for base components
 * 
**/

class AppRouter extends Component {
    render() {
        return (
            <Switch>
                <Route exact path={`/home`} component={Home} />
                <Route path={`/locations`} component={LocationsRouter} />

                <Route path={`/sales`} component={SalesRouter} />

                <Route path={`/buyer`} component={BuyerRouter} />    

                <Route path={`/invoice`} component={InvoiceRouter} />
                <Route path={`/reports`} component={ReportRouter} />
                {/* <Route path={`/compliance`} component={ComplianceRouter} /> */}
                <Route path={`/messages`} component={MessageRouter} />
                <Route path={`/declined-cards`} component={DeclinedCards} />
                <Route path={`/membership`} component={MembershipRouter} />
                {/* <Route exact path={`/support`} component={SupportView} /> */}
                <Route path={`/ctbids-content`} component={CtbidsContentRouter} />
                <Route exact path={`/profile`} component={Profile} />
                <Route exact path={`/change-password`} component={ChangePassword} />
                <Route path={`/alerts`} component={AlertRouter} />
                <Route exact path={`/fulfillment/:invoiceId`} component={Fullfillment} />
                <Route path={`/help-center`} component={helpCenterRouter} />
                <Redirect to="/home" />
            </Switch>
        );
    }
}
export default connect(state => state)(AppRouter);